/**
 * ```
    $state.go(STATE_MAPPINGS.search);
 * ``` 
 * ### Notes
 *  Module structure:
 *    route (app.runner.search) --> runner.flows.search.tmpl
 *      flowsIminGroups                   // Handles the list of groups
 *        flowsIminGroup                 // Handles each group (which contains a group.name and the group.flows)
 *          flowsIminGroupHeader          // Handles the group header for a group of flows
 *          flowsIminGroupFlows            // Handles the flow list for a group
 *            flowsIminGroupFlow          // Handles each flow in the group
 *              --> runner.flows.imin.group.flow.tmpl.html //uses the flow-list directive to present all the flows in the group
 * ### Properties
 * #### Inputs
 */

'use strict';
import angular from 'angular';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';
///
/// This state displays the flow search result
///

// Register the application's routes configuration.
angular.module('flowingly.runner.flows.search').config(config);

// Inject the dependencies.
config.$inject = ['$stateProvider'];

function config($stateProvider: angular.ui.IStateProvider) {
  $stateProvider.state(STATE_MAPPINGS.search, {
    url: 'search?:term',
    params: { title: 'Search Results' },
    template:
      '<runner-flows-search search-term="$resolve.searchTerm"></runner-flows-search>',
    resolve: {
      searchTerm: [
        '$stateParams',
        ($stateParams: angular.ui.IStateParamsService) => $stateParams.term
      ]
    }
  });
}
